import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSheet,{staticClass:"surface"},[_c(VContainer,{attrs:{"fluid":""}},[_c(VRow,{attrs:{"dense":""}},_vm._l((_vm.items),function(person,index){return _c(VCol,{key:index,attrs:{"cols":"12","md":"4"}},[_c('member-card',{attrs:{"id":person._id,"name":person.name,"image":_vm.makeImageSrc(person.avatarImage),"title":person.title,"role":person.role,"certificates":"","email":person.email,"phone":person.mobile}})],1)}),1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }